<app-notification-layout
  [desktopImageSrc]="'/Icono-falla.png'"
  [mobileImageSrc]="'/Icono-falla.png'"
  [title]="'!Sin drama!'"
  [subtitle]="'Puedes hacerlo marcando al *111# o por nuestros canales.'"
>
  <div class="flex-1 mt-10 flex flex-col gap-1 justify-center items-center">
    <button
      class="bg-red-500 w-[124px] h-[51px] text-[15px] uppercase text-white rounded-full p-4 font-extrabold text-xl mt-16"
      routerLink="/"
    >
      Finalizar
    </button>
  </div>
</app-notification-layout>
